import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import type { YakitoriSpot } from '../lib/types';

type Props = {
  open: boolean;
  onClose: () => void;
  spots: YakitoriSpot[];
};

/** "Press K" easter egg. Yakitori Manifest overlay.
 * Portalled to body so fixed positioning escapes any clipping ancestor. */
export function KSecret({ open, onClose, spots }: Props) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'rgba(22,19,16,0.88)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40,
        fontFamily: 'var(--font-mono)',
        color: 'var(--paper)',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: 680,
          width: '100%',
          background: 'var(--paper)',
          color: 'var(--ink)',
          padding: '40px 44px',
          position: 'relative',
          boxShadow: '0 30px 80px rgba(0,0,0,0.4)',
          border: '1px solid var(--ink)',
        }}
      >
        <div className="eyebrow-accent" style={{ marginBottom: 14 }}>
          ✦ classified · for your eyes only ✦
        </div>
        <div
          className="serif"
          style={{
            fontSize: 64,
            lineHeight: 0.95,
            letterSpacing: -1.6,
            marginBottom: 18,
          }}
        >
          The Yakitori <em>Manifest.</em>
        </div>
        <div
          className="serif italic"
          style={{ fontSize: 17, opacity: 0.78, marginBottom: 28 }}
        >
          My personal ranking, skewer by skewer. Tell no one — especially not the master
          at #3.
        </div>
        <div style={{ borderTop: '1px solid var(--ink)' }}>
          {spots.map((r) => (
            <div
              key={r.n}
              style={{
                display: 'grid',
                gridTemplateColumns: '50px 1fr auto',
                gap: 16,
                padding: '14px 0',
                borderBottom: '1px solid var(--soft)',
                alignItems: 'baseline',
              }}
            >
              <span style={{ color: 'var(--accent)', fontSize: 13 }}>{r.n} ▸</span>
              <span className="serif" style={{ fontSize: 24 }}>
                {r.name}
              </span>
              <span
                style={{
                  fontSize: 11,
                  textTransform: 'uppercase',
                  letterSpacing: 1.2,
                  opacity: 0.65,
                }}
              >
                {r.hood}
              </span>
            </div>
          ))}
        </div>
        <div
          style={{
            marginTop: 26,
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: 10,
            textTransform: 'uppercase',
            letterSpacing: 1.5,
            opacity: 0.6,
          }}
        >
          <span>press K or ESC to close</span>
          <span>— D.M.</span>
        </div>
      </div>
    </div>,
    document.body
  );
}
